/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_FairValue_FairValueAddUpdateResponseDto } from '../models/Wealthlane_AwardService_Dtos_FairValue_FairValueAddUpdateResponseDto';
import type { Wealthlane_AwardService_Dtos_FairValue_FairValueImportTemplateParseDto } from '../models/Wealthlane_AwardService_Dtos_FairValue_FairValueImportTemplateParseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FairValueLegacyService {

    /**
     * @param requestType 
     * @param tenantId 
     * @param userId 
     * @param taskId 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_FairValue_FairValueAddUpdateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppFairValueLegacyProcessAddUpdateOptionAward(
requestType?: number,
tenantId?: string,
userId?: string,
taskId?: string,
requestBody?: Array<Wealthlane_AwardService_Dtos_FairValue_FairValueImportTemplateParseDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueAddUpdateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/fair-value-legacy/process-add-update-option-award',
            query: {
                'RequestType': requestType,
                'TenantId': tenantId,
                'userId': userId,
                'taskId': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param log 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFairValueLegacyLogsWithDateTime(
log?: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fair-value-legacy/logs-with-date-time',
            query: {
                'log': log,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
